



























































































import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator'
// eslint-disable-next-line
import { format, parse } from 'date-fns'

const DEFAULT_DATE = ''
const DEFAULT_TIME = '00:00:00'
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
const DEFAULT_DIALOG_WIDTH = 340
const DEFAULT_CLEAR_TEXT = 'CLEAR'
const DEFAULT_OK_TEXT = 'OK'

@Component
export default class DateTimePicker extends Vue {
  $refs!: { timer: any }

  // @ts-ignore
  @Model('input', { type: [String, Date] }) datetime: any

  // @ts-ignore
  @Prop({ required: false, default: null }) datetime: any
  @Prop({ required: false, default: false }) persistent: boolean
  @Prop({ required: false, default: false }) disabled: boolean
  @Prop({ required: false, default: false }) loading: boolean
  @Prop({ required: false, default: '' }) label: string
  @Prop({ required: false, default: DEFAULT_DIALOG_WIDTH }) dialogWidth: number
  @Prop({ required: false, default: DEFAULT_DATE_FORMAT }) dateFormat: string
  @Prop({ required: false, default: DEFAULT_TIME_FORMAT }) timeFormat: string
  @Prop({ required: false, default: DEFAULT_CLEAR_TEXT }) clearText: string
  @Prop({ required: false, default: DEFAULT_OK_TEXT }) okText: string
  @Prop({ required: false }) textFieldProps: object
  @Prop({ required: false }) datePickerProps: object
  @Prop({ required: false }) timePickerProps: object
  @Prop({ required: false, default: () => [] }) rules: Array<any>

  display: boolean = false
  activeTab: number = 0
  date: string = DEFAULT_DATE
  time: string = DEFAULT_TIME

  get dateTimeFormat() {
    return `${this.dateFormat} ${this.timeFormat}`
  }

  get defaultDateTimeFormat() {
    return `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
  }

  get formattedDatetime() {
    return this.selectedDatetime ? format(this.selectedDatetime, this.dateTimeFormat) : ''
  }

  get selectedDatetime() {
    if (this.date && this.time) {
      let datetimeString = `${this.date} ${this.time}`
      if (this.time.length === 5) {
        datetimeString += ':00'
      }
      return parse(datetimeString, this.defaultDateTimeFormat, new Date())
    }
    return null
  }

  get dateSelected() {
    return !this.date
  }

  init() {
    if (!this.datetime) {
      return
    }

    let initDateTime
    if (this.datetime instanceof Date) {
      initDateTime = this.datetime
    } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
      // see https://stackoverflow.com/a/9436948
      initDateTime = parse(this.datetime as string, this.dateTimeFormat, new Date())
    }

    this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
    this.time = format(initDateTime, DEFAULT_TIME_FORMAT)
  }

  okHandler() {
    if (!this.selectedDatetime) return
    this.resetPicker()
    this.$emit('input', this.selectedDatetime)
  }

  clearHandler() {
    this.resetPicker()
    this.date = DEFAULT_DATE
    this.time = DEFAULT_TIME
    this.$emit('input', null)
  }

  resetPicker() {
    this.display = false
    this.activeTab = 0
    if (this.$refs.timer) {
      this.$refs.timer.selectingHour = true
    }
  }

  showTimePicker() {
    this.activeTab = 1
  }

  mounted() {
    this.init()
  }

  @Watch('datetime')
  onChangeDateTime(val: any) {
    this.init()
  }
}
